export const CREATE_PAYMENT_MESSAGE = "Payment created successfully";
export const UPDATE_INVOICE_MESSAGE = "Invoice updated successfully";
export const CREATE_INVOICE_MESSAGE = "Invoice created successfully";
export const NO_PAYMENT_GATEWAY_SELECTED = "No payment gateway has been selected";
